<template>
  <div class="google-table">
    <Heading
      :text="header"
      size="lg"
      tag="h2"
      text-uppercase
      align="center"
      spaces-top
      spaces-bottom
    />
    <GridContainer
      padding
      class="google-table__body"
    >
      <GridRow class="google-table__body__row">
        <GridColumn
          :xs="0"
          :sm="4"
        ></GridColumn>
        <GridColumn
          class="google-table__body__product-cell"
          :xs="6"
          :sm="4"
        >
          <Heading
            text="Pixel Buds Pro"
            size="sm"
            spaces-bottom
            tag="span"
          />
          <CdnImage
            :width="200"
            :height="200"
            alt="Pixel Buds Pro"
            class="google-table__body__product-cell__image"
            src="/content/content-images/landingpages/google/ddb15bafbcd90d38150b0ea7d19063f3/pixel-buds-pro-vergleich.png"
            render-without-figure
            lazy
          />
          <AvailableColors :colors="getColorsByIdx(0)" />
        </GridColumn>
        <GridColumn
          class="google-table__body__product-cell"
          :xs="6"
          :sm="4"
        >
          <Heading
            text="Pixel Buds A-Series"
            size="sm"
            spaces-bottom
            tag="span"
          />
          <CdnImage
            :width="200"
            :height="200"
            alt="Pixel Buds A-Series"
            class="google-table__body__product-cell__image"
            src="/content/content-images/landingpages/google/aeb31406d1091811018cf1de4b021c6a/pixel-buds-a-series-vergleich.png"
            render-without-figure
            lazy
          />
          <AvailableColors :colors="getColorsByIdx(1)" />
        </GridColumn>
      </GridRow>
      <GridRow
        v-for="row in tableData"
        :key="row.header"
        class="google-table__body__row google-table__body__row--divider"
      >
        <GridColumn
          class="google-table__body__row__header"
          :xs="12"
          :sm="4"
          align="center"
        >
          {{ row.header }}
        </GridColumn>
        <GridColumn
          align="center"
          :xs="6"
          :sm="4"
        >
          {{ row.budsPro }}
        </GridColumn>
        <GridColumn
          align="center"
          :xs="6"
          :sm="4"
        >
          {{ row.budsA }}
        </GridColumn>
      </GridRow>
      <GridRow
        align-h="center"
        style="padding: 1rem 0"
        class="google-table__body__row"
      >
        <GridColumn
          :xs="0"
          :sm="4"
        ></GridColumn>
        <GridColumn
          align="center"
          :xs="6"
          :sm="4"
        >
          <AddToCartButtonContainer
            v-if="offers[0]?.offer"
            :offer="offers[0].offer"
          />
        </GridColumn>
        <GridColumn
          align="center"
          :xs="6"
          :sm="4"
        >
          <AddToCartButtonContainer
            v-if="offers[1]?.offer"
            :offer="offers[1].offer"
          />
        </GridColumn>
      </GridRow>
    </GridContainer>
  </div>
</template>

<script>
import { GridContainer, GridRow, GridColumn, Heading } from '@i22/td-longtail-vue-components';
import CdnImage from '~/components/cdn-image.vue';
import AvailableColors from '~/components/google/available-colors.vue';
import { getFirstOfferAlternatives } from '@i22/rocket';
import AddToCartButtonContainer from '~/components/product-detail/add-to-cart-button-container.vue';

export default {
  name: 'GoogleTable',
  components: {
    AddToCartButtonContainer,
    GridContainer,
    GridRow,
    GridColumn,
    Heading,
    CdnImage,
    AvailableColors,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    offers: {
      type: Array,
      default: () => [],
    },
    header: {
      type: String,
      default: '',
    },
  },
  methods: {
    getColorsByIdx(idx) {
      if (!this.offers[idx]?.offer) return [];
      const alternatives = getFirstOfferAlternatives(this.offers[idx].offer?.productAlternatives);
      return alternatives?.variants?.COLOR?.items?.map((item) => item.color.code) || [];
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.google-table {
  &__body {
    font-size: normal;
    overflow-x: hidden;

    @include mq($mq-md) {
      font-size: larger;
    }

    @include mq($mq-lg) {
      font-size: x-large;
    }

    &__product-cell {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 2rem;
    }

    &__row {
      align-items: center;

      &__header {
        border-bottom: 1px solid color(grey, 29000);
        margin-bottom: 1rem;
        padding-bottom: 1rem;
        font-weight: 500;
        text-align: center;

        @include mq($mq-sm) {
          text-align: start;
          border-bottom: none;
          margin-bottom: unset;
          padding-bottom: unset;
          font-weight: unset;
        }
      }

      &--divider {
        padding: 1rem 0;

        @include mq($mq-sm) {
          border-bottom: 1px solid color(grey, 29000);
        }

        :last-child,
        :nth-last-child(2) {
          white-space: pre-wrap;
        }
      }
    }
  }
}
</style>
